<template>
  <el-drawer custom-class="Setting" title="设置" :visible="isShowSetting" direction="rtl" @close="setIsShowSetting(false)">
    <p>
      <el-button type="primary" size="mini" @click="toLogout">退出登录</el-button>
    </p>
    <p>
      <el-select :value="curTheme" placeholder="请选择" @change="setCurTheme">
        <el-option v-for="item in themeList" :key="item.theme" :label="item.theme" :value="item.theme"> </el-option>
      </el-select>
    </p>
  </el-drawer>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Setting',
  computed: {
    ...mapState('layout', ['isShowSetting']),
    ...mapState('theme', ['themeList', 'curTheme'])
  },
  methods: {
    ...mapMutations('layout', ['setIsShowSetting']),
    ...mapMutations('theme', ['setCurTheme']),
    ...mapActions('sys', ['toLogout'])
  }
}
</script>
<style lang="scss" scoped>
:deep(.Setting) {
  .el-drawer__body {
    padding: 0 20px;
    > p {
      margin-bottom: 12px;
    }
  }
}
</style>
